"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFathom = exports.FathomContext = void 0;

var _react = require("react");

var FathomContext = (0, _react.createContext)(null);
/**
 * Returns fathom instance for use in a component.
 *
 * @returns {object} (pageView(path, data), goal(goalId, goalValue, data))
 */

exports.FathomContext = FathomContext;

var useFathom = function useFathom() {
  return (0, _react.useContext)(FathomContext);
};

exports.useFathom = useFathom;